import { render, staticRenderFns } from "./ViaTokenLogin.vue?vue&type=template&id=5b019008"
import script from "./ViaTokenLogin.vue?vue&type=script&lang=js"
export * from "./ViaTokenLogin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports